import React, { PropTypes } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { BASE_IMAGES_URL } from "Constants";
import Button from "react-bootstrap-button-loader";
import AdvertisementuserlistModal from "../viewuserlistmodal";
import LocaleStrings from "Languages";

class AdsviewlistItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resetpassword: false,
      loading: false,
      allowingaccess: false,
      selectedUsers: [],
      showEmailPreviewModal: false,
      isOpen: false,
    };
  }
  openModal = () => {
    this.setState({
      isOpen: true,
    });
  };
  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    let { values, index } = this.props;
    // console.log('advaluesview',values)
    let name = "-";
    let imagePath = "-";
    if (values.bannerimg !== null) {
      name = values.bannerimg;
      imagePath = `${BASE_IMAGES_URL}/${name}?api_key=${this.props.session.apiKey}`;
    }
    return (
      <tr key={index} id={index}>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}>
            <img style={{ width: "100px", height: "75px" }} src={imagePath} />
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}>
            <div className="vcenter">{_.startCase(values.advtname)}</div>
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}>
            <div className="vcenter ">{_.startCase(values.screen)}</div>
          </div>
        </td>
        <td>
          <div
            className="row"
            style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}>
            <div className="vcenter ">{values.totalcount}</div>
          </div>
        </td>
        <td>
          <Button className="btn-primary" onClick={() => this.openModal()}>
            {LocaleStrings.analytics_ad_viewedby}
          </Button>
        </td>
        {this.state.isOpen ? (
          <AdvertisementuserlistModal
            isOpen={this.state.isOpen}
            onClose={this.closeModal}
            data={values}
          />
        ) : (
          ""
        )}
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};

export default connect(mapStateToProps, {})(AdsviewlistItem);
